var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col-12 " }, [
      _c("div", { staticClass: "row mx-0" }, [
        _vm.previous_summary.length != 0
          ? _c(
              "div",
              {
                staticClass: "col-12 px-0 position-relative",
                attrs: { id: "Previous_sum" },
              },
              [
                _c(
                  "ul",
                  {
                    staticClass: "previouslist p-0 m-0 nav nav-tabs",
                    staticStyle: { background: "#0d6ccd" },
                    attrs: { id: "myTab" },
                  },
                  _vm._l(_vm.previous_summary, function (data, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "nav-item",
                        class: [index == 0 ? "active" : ""],
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.getFormattedDate(data.visit_date)) +
                            "\n                            "
                        ),
                        _c("a", {
                          staticClass: "action-view",
                          style: [
                            data.doctor_summary.length == 0
                              ? { "pointer-events": "none", opacity: "0.5" }
                              : { "pointer-events": "visible", opacity: 1 },
                          ],
                          attrs: {
                            href: "javascript:void(0);",
                            "data-toggle": "modal",
                            "data-target": "#previoussummary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.GetPreviousSummaryByDate(
                                data.visit_date,
                                index
                              )
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          : _c("div", [
              _c("p", [_vm._v(_vm._s(_vm.$t("Noprevioussummaryfound")))]),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }